<template>
  <!-- 在线律师 -->
  <div class="law_ranking text_center">
    <sec-title
      ac-text="律师"
      Text="排行榜"
      desc-text="用真实数据还原律师服务水平，7日律师排行榜"
	  :showmore = 'false'
    />
    <div class="ranking_list between">
      <ranking-ling class="rank_item"></ranking-ling>
      <ranking-ling class="rank_item"></ranking-ling>
      <ranking-ling class="rank_item"></ranking-ling>
    </div>
  </div>
</template>

<script>
import rankingLing from "../components/rankingLing";
import secTitle from "../components/secTitle";
export default {
  components: {
    secTitle,
    rankingLing,
  },
  created() {
  	this.$http.home.lawyerrank({
		type:1
	}).then(res => {
		
	})
  },
};
</script>

<style lang="scss" scoped>
.law_ranking {
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 50px;
  padding-top: 50px;
  .ranking_list {
    .rank_item {
      width: 380px;
      padding: 28px 17px;
      box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.08);
    }
  }
}
</style>